module.exports = __webpack_public_path__ + "static/media/look-board.0c4f03df.jpg";